import { useParams, Navigate } from 'react-router-dom';
import RepositoryBatchList from '../Repository/RepositoryBatchList';
import { useSubscription } from '../../hooks/useSubscription';

const DEFAULT_PAGE_SIZE = 10;

const RepositoryBatchListWrapper = () => {
    const { repo_id } = useParams();
    const repositoryId = repo_id ? parseInt(repo_id) : null;
    const { isTrial, isActive } = useSubscription();

    // Redirect to pricing if Trial or inactive subscription
    if (isTrial || !isActive) {
        return <Navigate to="/pricing" replace />;
    }

    return <RepositoryBatchList pageSize={DEFAULT_PAGE_SIZE} repositoryId={repositoryId} />;
};

export default RepositoryBatchListWrapper;

